import * as React from 'react';

import styles from './case-report-info.scss';

interface CaseListingNoResultsFoundProps {
  translation: any;
}

export const CaseListingNoResultsFound = React.memo(({
  translation
}: CaseListingNoResultsFoundProps) => {
  return (
    <div className={styles.noResultsFound}>
      <div>{translation.search_no_hits}</div>
    </div>
  );
});
